import { Injectable } from '@angular/core';
import { ApiRequestService } from './api-request.service';
import { ApiResponseModel } from '../models/api-response.model';
import { SiteModel } from '../models/site.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SitesService {
  private readonly resourceUrl = 'v1/sites';

  constructor(private api: ApiRequestService) {}

  public find(
    id: number,
    eager_load = false
  ): Observable<ApiResponseModel<SiteModel>> {
    return this.api.makeRequestObservable(
      'get',
      this.resourceUrl + `/${id}`,
      {},
      { eager_load: eager_load }
    );
  }

  public update(site: SiteModel): Observable<ApiResponseModel<SiteModel>> {
    return this.api.makeRequestObservable(
      'put',
      this.resourceUrl + `/${site.id}`,
      site
    );
  }

  public delete(ids: number[]): Observable<{}> {
    return this.api.makeRequestObservable(
      'delete',
      this.resourceUrl + '/' + ids.join(',')
    );
  }
}
